import { render, staticRenderFns } from "./ed-homework-widget-course-section.vue?vue&type=template&id=72d98a0d&scoped=true&"
import script from "./ed-homework-widget-course-section.ts?vue&type=script&lang=ts&"
export * from "./ed-homework-widget-course-section.ts?vue&type=script&lang=ts&"
import style0 from "./ed-homework-widget-course-section.scss?vue&type=style&index=0&id=72d98a0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d98a0d",
  null
  
)

export default component.exports